import { RFValue } from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import FastImage from 'react-native-fast-image';
import { Dimensions } from 'react-native';

const { height } = Dimensions.get('window')

export const ModalContent = styled.View`
  background-color: ${({ theme }) => theme.colors.background};
  padding: ${RFValue(18)}px ${RFValue(16)}px;
  padding-bottom: ${RFValue(24)}px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  height: ${height * 0.7}px;
`;

export const ModalHeader = styled.View`
  margin-bottom: ${RFValue(8)}px;
`;

export const ModalTitle = styled.Text`
  color: ${({ theme }) => theme.colors.title};
  font-size: ${RFValue(16)}px;
  font-family: ${({ theme }) => theme.fonts.semibold};
`;

export const ModalSubtitle = styled.Text`
  color: ${({ theme }) => theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({ theme }) => theme.fonts.regular};
`;

export const InputGroup = styled.View`
  margin-bottom: ${RFValue(16)}px;
`;

export const Section = styled.View`
  margin-top: ${RFValue(4)}px;
  flex-grow: 1;
`;

export const SectionTitle = styled.Text`
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.title};
  font-size: ${RFValue(14)}px;
  margin-bottom: ${RFValue(12)}px;
`;

export const PaymentInfo = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const Payment = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const BrandContainer = styled.View`
  width: ${RFValue(35)}px;
  height: ${RFValue(35)}px;
  align-items: center;
  border: 2px solid ${({ theme }) => theme.colors.border3};
  border-radius: ${RFValue(10)}px;
  justify-content: center;
`;

export const BrandImage = styled(FastImage)`
  width: ${RFValue(20)}px;
  height: ${RFValue(13)}px;
`;

export const PaymentMethodInfo = styled.View`
  margin-left: ${RFValue(12)}px;
`;

export const PaymentTitle = styled.Text`
  font-family: ${({ theme }) => theme.fonts.semibold};
  color: ${({ theme }) => theme.colors.text_dark};
  font-size: ${RFValue(12)}px;
`;
